import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';

export default function BrandsCarousel({ data, sectionTitle }) {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 5,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (

    <div className="container">
      <SectionHeading title={sectionTitle} center />

      <Spacing md="72" lg="50" />

      <Slider {...settings} className="cs_gap_20">
        {data?.map((item, index) => (
          <div key={index}>
            <div className="cs_brands cs_style_2">
              <Link
                to={item.url}
              >
                <img src={item.iconUrl} alt={item.title} />
              </Link>

            </div>
            <div className="content" style={{
              textAlign: "center"
            }}>
              <h6>{item.title} </h6>
              <p>{item.subTitle}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>

  );
}
